import React, { useEffect, useState } from "react";
import { Fab } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";

import useAuth from "../hooks/useAuth";
import { closeCrispChat, openCrispChat } from "../hooks/useCrispContext";
import { initializeCrispSdk } from "../hooks/useCrispSession";

const CrispGlobalChat = () => {
  const { user, auth } = useAuth();
  const [isChatOpen, setIsChatOpen] = useState(false);

  const enabled = Boolean(auth.token && user?.admin);

  useEffect(() => {
    if (!enabled) {
      closeCrispChat();
      setIsChatOpen(false);
      return undefined;
    }

    let handleChatClosed;

    initializeCrispSdk().then(() => {
      if (typeof window.$crisp === "undefined") {
        return;
      }

      handleChatClosed = () => {
        closeCrispChat();
        setIsChatOpen(false);
      };
      window.$crisp.push(["on", "chat:closed", handleChatClosed]);
    });

    return () => {
      if (handleChatClosed && window.$crisp) {
        window.$crisp.push(["off", "chat:closed"]);
      }
    };
  }, [enabled]);

  if (!enabled) {
    return null;
  }

  const handleToggleChat = async () => {
    try {
      if (isChatOpen) {
        closeCrispChat();
        setIsChatOpen(false);
        return;
      }
      await openCrispChat();
      setIsChatOpen(true);
    } catch (error) {
      console.error("Unable to open Crisp chat.", error);
    }
  };

  return (
    <div style={{ position: "fixed", bottom: 20, right: 20, zIndex: 1300 }}>
      {!isChatOpen && (
        <Fab color="primary" aria-label="Open chat" onClick={handleToggleChat}>
          <ChatIcon />
        </Fab>
      )}
    </div>
  );
};

export default CrispGlobalChat;
